import { dapRedirectCommon } from '~/data/common/config/redirect'
export let dapRedirect = Object.freeze(deepMerge(dapRedirectCommon, {
  // 旧URLリダイレクト
  '/static/ja/earthquake.html': '/gallery/ndl-ChronologySinceMeiji',
  '/static/ja/edoearthquake.html': '/gallery/ndl-ChronologyEdo',
  '/static/db': '/database',
  '/static/ja/kantodaishinsai.html': '/gallery/ndl-KantoDaishinsai1923',
  '/static/about': '/about#1avlc59n89y3d',
  '/static/ja/kioku.html': '/gallery/ndl-Kirokushi',
  '/static/support': '/about-us',
  '/static/help': '/help',
  '/static/about/project': '/about-project',
  '/static/450': '/about-project',
  '/static/contact': '/contact',
  '/static/collection': '/about#ci1gx5vd5g4d',
  '/static/reproduction': '/about#1xfsofrprr3rt',
  '/static/459': '/brochure',
  '/static/copyright': '/about#1cudnrx1d9efta',
  '/static/2025/11/271': '/gallery/ndl-R07dSymposium',
  '/static/2024/11/06': '/gallery/ndl-R06dSymposium',
  '/static/2023/11/171': '/gallery/ndl-R05dSymposium',
  '/static/2022/11/171': '/gallery/ndl-R04dSymposium',
  '/static/2021/11/041': '/gallery/ndl-R03dSymposium',
  '/static/2020/11/12': '/gallery/ndl-R02dSymposium',
  '/static/2019/11/07': '/gallery/ndl-R01dSymposium',
  '/static/2018/11/141': '/gallery/ndl-H30dSymposium',
  '/static/2017/10/311': '/gallery/ndl-H29dSymposium',
  '/static/2016/11/22': '/gallery/ndl-H28dSymposium',
  '/static/2015/11/18': '/gallery/ndl-H27dSymposium',
  '/static/2014/11/3': '/gallery/ndl-H26dSymposium',
  '/static/2013/11/5': '/gallery/ndl-H25dSymposium',
  '/static/2013/03/h24sympo': '/gallery/ndl-H24dSymposium',
  '/static/2012/03/h23sympo': '/gallery/ndl-H23dSymposium',
}))
